import Cookies from "js-cookie";

// const TokenKey = 'ESS-TOKEN'

// export function getToken() {
//   return Cookies.get(TokenKey);
// }

export function setEssToken(ess_token) {
  return Cookies.set('ESS-TOKEN', ess_token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
